import clsx from 'clsx'

import { Breadcrumb, BreadcrumbItem } from '@wartek-id/breadcrumb'

import type { FC } from 'react'

interface PageBreadcrumbProps {
  currentPageIndex?: number
  className?: string
}

const PageBreadcrumb: FC<PageBreadcrumbProps> = ({
  currentPageIndex,
  className,
}) => {
  const breadcrumbItems = [
    'Konfirmasi Data Diri',
    'Pakta Integritas',
    'Halaman Ujian',
  ]
  return (
    <div className={clsx('hidden px-4 mb-6 lg:block', className)}>
      <Breadcrumb>
        {breadcrumbItems.map((thisItem, index) => (
          <BreadcrumbItem
            key={`breadcrumb_item_${index}`}
            isCurrentPage={currentPageIndex === index}
          >
            {thisItem}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </div>
  )
}

export default PageBreadcrumb
